import { makeStyles, tokens } from '@fluentui/react-components';

export const useNavigationTabPanelStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: tokens.spacingVerticalXXL,
  },
});
